import { z } from 'zod';
import { SchemaTimestamp, ZodArrayToEnum } from '@axiom/types';
import { CandidateEngagementsConst } from '@axiom/const';

import { OpportunitySchema } from './opportunity';
import { PositionSchema } from './position';
import { ZodCandidateOpportunityCandidateStatuses } from './candidate-opportunities-candidate-statuses';
import { CalendarEventSchema } from './calendar';

export const ZodCandidateEngagementStates = z.enum(
  ZodArrayToEnum(Object.values(CandidateEngagementsConst.EngagementStates))
);

export const ZodInterviewingStates = z.enum(
  ZodArrayToEnum([
    CandidateEngagementsConst.EngagementStates.InterviewingUnaccepted,
    CandidateEngagementsConst.EngagementStates
      .InterviewingClientUnacceptedTalentAccepted,
    CandidateEngagementsConst.EngagementStates.InterviewingConfirmed,
  ])
);

export const CandidateEngagementSchema = z.object({
  id: z.string().uuid(),
  candidateStatus: ZodCandidateOpportunityCandidateStatuses,
  candidateStatusUpdatedAt: SchemaTimestamp,
  onboardingEmailSentAt: SchemaTimestamp.nullable(),
  engagementState: ZodCandidateEngagementStates.nullable(),
  hasMovedPastWarmedWithoutAnsweringWarmingQuestions: z.boolean(),
  opportunity: OpportunitySchema.pick({
    id: true,
    jobName: true,
    stageCode: true,
  }),
  position: PositionSchema.pick({
    id: true,
    startDate: true,
  }),
  interviews: z.array(
    CalendarEventSchema.pick({
      endTime: true,
      startTime: true,
    }).extend({
      interviewingState: ZodInterviewingStates,
    })
  ),
});

export type CandidateEngagement = z.infer<typeof CandidateEngagementSchema>;
